import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, Observable } from 'rxjs';
import { CoinspaidCurrency, CoinspaidCurrencyRates } from '@models/currencies';
import { Notifier } from './notifier.service';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
    providedIn: 'root',
})
export class DepositService {
    constructor(
        private http: HttpClient,
        private notifier: Notifier,
        private translateService: TranslocoService,
    ) {}

    baseUrl = environment.apiUrl;
    private apiUrl = `${this.baseUrl}/payment`;
    depositAmount(data: any) {
        return this.http
            .post(`${this.apiUrl}/sale`, data, {
                withCredentials: true,
                responseType: 'text',
                observe: 'response',
            })
            .pipe(
                catchError((error) => {
                    if (JSON.parse(error.error).errorCode == 1001) {
                        const message = this.translateService.translate(
                            'transactions.deposit.amount_exceeds_limit',
                        );
                        this.showNotifier(message, 'snackbar-error', 'Close', 5000);
                    }
                    throw error;
                }),
            );
    }

    showNotifier(message, type, button, duration) {
        this.notifier.openNotifier(message, type, button, duration);
    }

    sendUserResponse(data: any) {
        this.showNotifier(data, 'snackbar-success', 'Close', 5000);
    }

    getCoinsPaidCurrencies(): Observable<CoinspaidCurrency[]> {
        return this.http.get<CoinspaidCurrency[]>(`${this.apiUrl}/coins-paid-currencies`, {
            withCredentials: true,
        });
    }

    getCoinsPaidCurrencyRates(): Observable<CoinspaidCurrencyRates[]> {
        return this.http.get<CoinspaidCurrencyRates[]>(`${this.apiUrl}/coins-paid-currency-rates`, {
            withCredentials: true,
        });
    }

    saveCoinspaid(data: { description: string; currency: string; paymentProviderId: string }) {
        return this.http.post(`${this.apiUrl}/sale`, data, {
            withCredentials: true,
            responseType: 'text',
            observe: 'response',
        });
    }
}
